import React, { createContext, useState, useContext, ReactNode } from 'react';

type Language = 'tr' | 'en';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const translations = {
  tr: {
    // Nav
    nav_home: "Ana Sayfa",
    nav_services: "Hizmetler",
    nav_portfolio: "Portfolyo",
    nav_pricing: "Fiyatlandırma",
    nav_contact: "İletişim",
    nav_quote: "Teklif Al",

    // Hero
    hero_badge: "Uçtan Uca Yazılım Hizmeti",
    hero_title_1: "Fikirlerinizi",
    hero_title_2: "Hayata Geçiriyoruz",
    hero_desc: "Mobil uygulama, web geliştirme ve UI/UX tasarımındaki uzman ekibimizle fikirlerinizi dijital gerçekliğe dönüştürüyoruz.",
    hero_btn_work: "İşlerimizi Gör",
    hero_btn_contact: "Bize Ulaşın",
    hero_ready_title: "Markanızı Dönüştürmeye Hazır Mısınız?",
    hero_ready_desc: "Rakiplerinizin önüne geçmeniz için en iyi teknolojileri kullanarak dijital ürünler tasarlıyoruz.",

    // Services
    services_eyebrow: "Hizmetlerimiz",
    services_title: "Neler Yapıyoruz?",
    services_desc: "Markanızın dijital varlığını güçlendirmek için 360 derece yazılım ve tasarım çözümleri sunuyoruz.",
    srv_mobile_title: "Mobil Uygulama",
    srv_mobile_desc: "iOS ve Android için yüksek performanslı, kullanıcı dostu native ve cross-platform uygulamalar.",
    srv_web_title: "Web Geliştirme",
    srv_web_desc: "Modern teknolojiler (React, Next.js) kullanılarak hazırlanan hızlı, güvenli ve ölçeklenebilir web siteleri.",
    srv_uiux_title: "UI/UX Tasarım",
    srv_uiux_desc: "Kullanıcı deneyimini merkeze alan estetik ve işlevsel arayüz tasarımları.",
    srv_enterprise_title: "Kurumsal Yazılım",
    srv_enterprise_desc: "İş süreçlerinizi optimize eden özel backend ve yönetim panelleri.",
    srv_ecommerce_title: "E-Ticaret Çözümleri",
    srv_ecommerce_desc: "Satışlarınızı artırmak için güvenli ödeme altyapısına sahip özel e-ticaret sistemleri.",
    srv_strategy_title: "Dijital Strateji",
    srv_strategy_desc: "Markanızı dijital dünyada büyütmek için veriye dayalı analiz ve yol haritaları.",

    // Portfolio
    portfolio_title: "Portfolyo",
    portfolio_desc: "Teknoloji ve estetiği birleştirdiğimiz seçkin projelerimiz.",
    filter_all: "Tümü",
    filter_mobile: "Mobil Uygulama",
    filter_web: "Web Sitesi",
    project_platform: "PLATFORM",
    project_type: "PROJE TÜRÜ",
    project_type_val: "Uçtan Uca Geliştirme",
    back_to_portfolio: "Geri Dön",
    project_not_found: "Proje Bulunamadı",
    back_home: "Ana Sayfaya Dön",
    visit_site: "Siteye Git",

    // Pricing
    pricing_eyebrow: "Fiyatlandırma",
    pricing_title: "Proje Paketleri",
    pricing_desc: "İhtiyacınıza en uygun çözümü seçin.",
    price_starting: "'den başlayan (KDV hariç)",
    pricing_final_note: "Kesin fiyat, proje kapsamına göre yazılı teklif ve sözleşmeyle belirlenir.",
    plan_startup: "Başlangıç",
    plan_business: "İşletme",
    plan_enterprise: "Kurumsal",
    price_quote: "Teklif Alın",
    plan_btn: "İletişime Geç",
    most_popular: "EN POPÜLER",

    // Pricing Features
    feat_corp_web: "Kurumsal Web Sitesi (5 Sayfa)",
    feat_seo: "Temel SEO Ayarları",
    feat_mobile: "Mobil Uyumlu Tasarım",
    feat_contact: "İletişim Formu Entegrasyonu",
    feat_adv_app: "Gelişmiş Web veya Mobil App",
    feat_custom_ui: "Özel UI/UX Tasarım",
    feat_cms: "Yönetim Paneli (CMS)",
    feat_blog: "Blog / Haber Modülü",
    feat_support: "Yayına alma sonrası tam destek",
    feat_ecommerce: "Kapsamlı E-Ticaret / SaaS",
    feat_fullstack: "Full-Stack Geliştirme",
    feat_native: "Native Mobil Uygulama (iOS/Android)",
    feat_api: "Özel API Geliştirme",
    feat_priority: "7/24 Öncelikli Destek",
    feat_security: "Yük Testi ve Güvenlik Analizi",

    // Contact
    contact_eyebrow: "İletişim",
    contact_title: "Bir Fikriniz mi Var?",
    contact_desc: "Projenizden bahsedin. Sizin için en uygun dijital çözümü birlikte inşa edelim.",
    lbl_name: "Ad Soyad",
    lbl_email: "E-posta",
    lbl_phone: "Telefon",
    lbl_whatsapp: "WhatsApp",
    lbl_message: "Mesajınız",
    lbl_subject: "Konu",
    btn_send: "Gönder",
    lbl_address: "Adres",
    contact_form_title: "Bize Ulaşın",
    contact_success_title: "Mesajınız Alındı!",
    contact_success_desc: "En kısa sürede sizinle iletişime geçeceğiz.",
    contact_sending: "Gönderiliyor...",
    ph_name: "John Doe",
    ph_email: "ornek@sirket.com",
    ph_subject: "Projeniz hakkında kısa bir başlık",
    ph_message: "Proje detaylarınızdan bahsedin...",

    // Footer
    footer_desc: "Dijital dünyada iz bırakmak isteyen markalar için yaratıcı tasarım ve güçlü yazılım çözümleri üretiyoruz.",
    quick_links: "Hızlı Linkler",
    rights_reserved: "Tüm hakları saklıdır.",
    designed_in: "İstanbul'da tutkuyla tasarlandı.",

    // Cookie consent (#125)
    consent_title: "Çerez tercihleri",
    consent_body: "Ziyaret istatistiği ve reklam ölçümü gibi isteğe bağlı analizleri yalnızca onayınla çalıştırıyoruz. Reddedersen bu ölçümler yapılmaz. Tercihini istediğin zaman değiştirebilir, detayları",
    consent_privacy_link: "Gizlilik Politikası",
    consent_body_after: "sayfasında inceleyebilirsin.",
    consent_reject: "Reddet",
    consent_accept: "Tümünü kabul et",
    consent_current_accepted: "Mevcut tercihin: isteğe bağlı analiz açık.",
    consent_current_rejected: "Mevcut tercihin: isteğe bağlı analiz kapalı.",
    consent_close: "Kapat",
    consent_preferences_link: "Çerez tercihleri",

    // Privacy policy (#125)
    privacy_eyebrow: "Gizlilik",
    privacy_title: "Gizlilik Politikası",
    privacy_intro_p1: "MBBE SOFTWARE, web sitesi ve teklif talebi süreçlerinde paylaşılan kişisel verileri yalnızca talebin değerlendirilmesi, telefon doğrulaması, iletişim kurulması, hizmet sürecinin yürütülmesi ve güvenlik amaçlarıyla işler.",
    privacy_intro_p2: "Teklif formu kapsamında kampanya, reklam, promosyon, haber bülteni veya toplu pazarlama iletisi gönderimi yapılmaz. Telefon ve e-posta bilgileriniz, yalnızca kendi teklif talebiniz hakkında size geri dönüş yapılması için kullanılır.",
    privacy_retention: "Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca ve her halde azami 1 yıl süreyle saklanır. Ziyaret istatistikleri için bu süre 180 gündür ve süre sonunda veriler otomatik olarak silinir. Güvenlik kayıtları, SMS doğrulama durumu ve işlem logları da bu kapsamda sınırlı süreyle tutulabilir.",
    privacy_kvkk_prefix: "Ayrıntılı veri sorumlusu bilgileri, işlenen veri kategorileri, hukuki sebepler, aktarım bilgileri, yurt dışına aktarım açıklaması ve başvuru kanalları için",
    privacy_kvkk_link: "Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni",
    privacy_kvkk_suffix: "'ni inceleyebilirsiniz.",
    privacy_cookie_title: "Çerezler ve isteğe bağlı analitik",
    privacy_cookie_intro: "Ziyaret istatistiklerini yalnızca açık rızanızla topluyoruz. Rıza vermediğinizde analitik kaydı oluşturulmaz; ancak adresiniz, kötüye kullanımı ve hız sınırını denetlemek için kısa süreli Redis sayaçlarında sayılmaya devam eder. Tercihinizi sayfa altındaki “Çerez tercihleri” bağlantısından istediğiniz zaman değiştirebilirsiniz.",
    privacy_cookie_what_title: "Ne toplanır",
    privacy_cookie_what_body: "Onay verdiğinizde, gezdiğiniz sayfa yolu ve proje bağlantısı, zaman damgası (mutlak zaman olarak saklanır; raporlar Europe/Istanbul zaman diliminde gösterilir), tarayıcı bilgisi (user agent), yönlendiren sayfa (referrer) ve yaklaşık coğrafi bilgi (ülke/bölge/şehir) ile birlikte, IP adresinizden türetilen anahtarlı bir ziyaretçi kimliği saklanır. Veritabanında ham IP adresi tutulmaz.",
    privacy_cookie_gtm_title: "Google Etiket Yöneticisi",
    privacy_cookie_gtm_body: "Site, Google Etiket Yöneticisi'ni (GTM-NFD67QXZ) Google Onay Modu v2 (Consent Mode) ile yükler. Varsayılan onaylar (ad_storage, analytics_storage, ad_user_data, ad_personalization) reddedildi (denied) olarak başlar ve siz “Tümünü kabul et”i seçene kadar kapalı kalır; seçiminiz bu bayraklara yansıtılır. Onay verdiğinizde Google'a veri aktarılabilir.",
    privacy_cookie_geo_title: "Coğrafi yaklaştırma (IPinfo)",
    privacy_cookie_geo_body: "Yalnızca onay verdiğiniz isteklerde ham IP adresiniz, ülke/bölge/şehir bilgisini almak için api.ipinfo.io hizmetine gönderilir; veritabanında yalnızca dönen ülke/bölge/şehir saklanır. Bu aktarım yalnızca rıza verilmiş olaylarda gerçekleşir.",
    privacy_cookie_consent_title: "Rıza nasıl çalışır",
    privacy_cookie_consent_body: "Seçiminiz tarayıcınızda saklanır (mbbe_cookie_consent, sürüm 1). Yalnızca açık ve güncel “kabul” seçimi ölçümü başlatır; seçim yoksa, reddettiyseniz, sürüm eskiyse veya saklama alanı okunamıyorsa ölçüm yapılmaz. Rızanızı geri çektiğinizde izleme hemen durur. Sunucu, yalnızca analyticsConsent: granted olarak işaretlenmiş istekleri kabul eder.",
    privacy_cookie_combined_title: "Analitik ve güvenlik kayıtları",
    privacy_cookie_combined_body: "İsteğe bağlı ziyaret istatistikleri ile güvenlik/telemetri kayıtları aynı bildirim altında birlikte ele alınır (2026-10-12 tarihli ürün kararı). page_visits kayıtları PostgreSQL'de 180 gün saklanır ve otomatik silinir; hız sınırı sayaçları ise istemci adresiyle anahtarlanmış olarak Redis'te kısa süreli (TRACK_RATE_LIMIT_WINDOW_SECONDS) tutulup süre sonunda silinir. Depolama ayrıdır, bildirim birdir.",
    privacy_cookie_retention_title: "Saklama ve silme",
    privacy_cookie_retention_body: "Analitik kayıtları 180 gün saklanır ve süre sonunda otomatik olarak silinir. Silinen kayıtlar yedeklerde, yedeklerin kendi saklama süresi dolana kadar kalabilir. Yönetici, tek bir ziyaretçinin kayıtlarını silmek için başvurulan IP veya gösterilen kimlikle eşleşen kayıtları silebilir.",
    privacy_cookie_ip_title: "IP ve ziyaretçi kimliği",
    privacy_cookie_ip_body: "IP adresiniz, sunucudaki gizli bir anahtarla HMAC-SHA256 ile takma adlaştırılır (hashed_ip). Anahtar olmadan kimlik hesaplanamaz; tablo tek başına sızsa, anahtar olmadan ham adresler kurtarılamaz. Anahtar ayarlı değilse kimlik hiç saklanmaz, ziyaretler sayılır ama bir ziyaretçiye bağlanamaz.",
    privacy_cookie_withdraw_title: "Tercihinizi değiştirme",
    privacy_cookie_withdraw_body: "Tercihinizi değiştirmek için sayfa altındaki “Çerez tercihleri”ne tıklayın, “Reddet” veya “Tümünü kabul et” ile güncelleyin. Değişiklik tüm açık sekmelerinizde hemen uygulanır.",
    privacy_disclaimer: "Bu sayfa hukuki danışmanlık değildir. Yayın sonrası bir avukat tarafından incelenecektir.",

    // Common
    loading: "Yükleniyor...",
    error: "Hata",
    success: "Başarılı",
    learn_more: "Daha Fazla",
    no_image: "Görsel Yok",

    // NotFound
    notfound_title: "Sayfa Bulunamadı",
    notfound_desc: "Aradığınız sayfa mevcut değil veya taşınmış olabilir.",
    notfound_home: "Ana Sayfaya Dön",

    // Contact Form Toggle
    contact_show_form: "İletişim Formunu Aç",
    contact_hide_form: "Formu Kapat",

    // Destek Layout & Header
    destek_support: "Destek",
    destek_logout: "Çıkış",
    destek_notifications: "Bildirimler",
    destek_unread_count: "okunmamış destek kaydı",
    destek_no_unread: "Okunmamış bildirim yok",
    destek_close_panel: "Bildirim panelini kapat",
    destek_refresh: "Yenile",
    destek_mark_all_read: "Tümünü okundu işaretle",
    destek_filter_all: "Tümü",
    destek_filter_unread: "Okunmamış",
    destek_filter_action: "Aksiyon bekleyen",
    destek_group_action: "Aksiyon bekleyen",
    destek_group_reply: "Ekip yanıtları",
    destek_group_completed: "Çözülen / kapanan",
    destek_group_rejected: "Reddedilen / hata",
    destek_loading_notifications: "Bildirimler yükleniyor",
    destek_notifications_load_error: "Bildirimler yüklenemedi. Lütfen tekrar deneyin.",

    // Push Notification Prompt
    push_unsupported: "Bu tarayıcı anlık destek bildirimlerini desteklemiyor. Panel açık kalır ve yeni kayıtları yenileyerek gösterir.",
    push_granted: "Tarayıcı bildirimi açık. Bu cihaz destek uyarılarını alır.",
    push_denied: "Bildirim izni kapalı. İzin ayarını tarayıcı adres çubuğundan tekrar açabilirsiniz.",
    push_prompt_title: "Yanıt gelince haber ver",
    push_prompt_desc: "Bu cihazda yalnızca destek yanıtları ve aksiyon bekleyen kayıtlar için tarayıcı bildirimi gösterilsin.",
    push_waiting_permission: "İzin bekleniyor",
    push_enable: "Bildirimleri aç",
    push_later: "Sonra",
    push_dismiss_aria: "Bildirim izni hatırlatıcısını kapat",

    // Login Page
    login_title_desc: "Destek talepleriniz için giriş yapın",
    login_email: "E-posta",
    login_password: "Şifre",
    login_btn: "Giriş Yap",
    login_contact_team: "Erişim bilgileriniz için ekibimizle iletişime geçin.",
    login_failed_title: "Başarısız",
    login_invalid_credential: "E-posta veya şifre hatalı.",
    login_too_many_requests: "Çok fazla deneme. Lütfen biraz sonra tekrar deneyin.",
    login_generic_error: "Giriş yapılamadı. Lütfen tekrar deneyin.",
    login_not_customer: "Bu hesabın destek portalına erişimi yok.",
    login_unverified: "Giriş doğrulanamadı. Lütfen tekrar deneyin.",

    // Issue List Page
    list_title: "Destek Talepleriniz",
    list_desc: "Açtığınız talepleri görüntüleyin ve takip edin.",
    list_new_btn: "Yeni Talep",
    list_search_placeholder: "Taleplerde ara…",
    list_search_aria: "Arama",
    list_empty: "Henüz bir talep oluşturmadınız.",
    list_load_more: "Daha fazla yükle",
    list_relative_just_now: "az önce",

    // New Issue Page
    new_title: "Yeni Destek Talebi",
    new_desc: "Sorununuzu mümkün olduğunca ayrıntılı açıklayın.",
    new_back_btn: "Taleplere dön",
    new_input_title: "Başlık",
    new_input_title_placeholder: "Boş bırakılırsa otomatik oluşturulur (ör. Montajcım_#3)",
    new_input_project: "Proje *",
    new_input_project_placeholder: "Proje seçin…",
    new_input_type: "Tür",
    new_input_priority: "Öncelik",
    new_input_desc: "Açıklama",
    new_input_desc_placeholder: "Sorunu adım adım, en az 150 karakter olacak şekilde açıklayın…",
    new_images_label: "Görseller (en az 1)",
    new_images_empty: "Ekran görüntüsü ekleyin",
    new_image_field_empty: "Görsel ekleyin",
    new_max_images_reached: "Maksimum görsel sayısına ulaşıldı.",
    new_file_field_select: "Dosya seç",
    new_file_uploaded: "Yüklendi",
    new_file_upload_failed: "Yüklenemedi",
    new_file_uploading: "Yükleniyor",
    new_file_remove_aria: "dosyasını kaldır",
    new_file_retry: "Tekrar dene",
    new_file_limit: "dosya başına en fazla {max} MB",
    new_file_types: "Desteklenen türler: PDF, ZIP, TXT, CSV, DOCX ve XLSX.",
    new_file_error_image: "Görselleri Resim Yükleme alanından ekleyin.",
    new_image_upload_failed: "Görsel yüklenemedi. Dosyayı kaldırıp yeniden ekleyin.",
    new_file_error_empty: "Boş dosyalar yüklenemez.",
    new_file_error_type: "Bu dosya türü desteklenmiyor.",
    new_file_error_size: "Dosya, bu alanın {max} MB sınırını aşıyor.",
    new_project_fields: "Proje Alanları",
    new_select_placeholder: "Seçiniz…",
    new_char_remaining: "karakter daha gerekiyor",
    new_char_count: "karakter",
    new_uploads_in_progress: "Yüklemeler devam ediyor…",
    new_submit_btn: "Talebi Gönder",
    new_toast_success_title: "Oluşturuldu",
    new_toast_success_desc: "Destek talebi oluşturuldu.",
    new_toast_failed_title: "Başarısız",
    new_toast_failed_desc: "Talep oluşturulamadı",
    new_toast_wait_title: "Bekleyin",
    new_toast_wait_projects: "Projeler yükleniyor, lütfen bekleyin.",
    new_toast_wait_uploads: "Yüklemeler devam ediyor, lütfen bekleyin.",

    // Validation Errors
    err_project_required: "Lütfen bir proje seçin.",
    err_title_min: "Başlık en az 3 karakter olmalı.",
    err_desc_min: "En az 150 karakter gerekiyor.",
    err_desc_repetitive: "Aynı metni tekrarlamayın; lütfen sorununuzu anlamlı şekilde açıklayın.",
    err_image_min: "En az {min} görsel gerekiyor.",
    err_image_max: "En fazla {max} görsel yükleyebilirsiniz.",
    err_file_required: "Bu alan için dosya yüklemelisiniz.",
    err_file_max: "En fazla 1 dosya yükleyebilirsiniz.",
    err_field_required: "Bu alan zorunlu.",
    err_field_max: "En fazla {max} karakter girebilirsiniz.",
    err_field_min: "En az {min} karakter gerekiyor.",
    err_field_repetitive: "Tekrarlı metin algılandı; lütfen bu alanı anlamlı şekilde doldurun.",
    err_general_image: "En az 1 görsel yüklemelisiniz.",

    // Issue Detail Page
    detail_load_error: "Talep yüklenemedi.",
    detail_created_at: "Oluşturuldu",
    detail_resolve_btn: "Çözüldü olarak işaretle",
    detail_images_title: "Görseller",
    detail_conversation_title: "Yazışma",
    detail_no_replies: "Henüz yanıt yok. Ekibimiz en kısa sürede dönüş yapacak.",
    detail_author_team: "MBBe Ekip",
    detail_author_self: "Siz",
    detail_reopen_title: "Yeniden açma isteği",
    detail_reopen_desc: "Talep kapalı. Konu devam ediyorsa kısa bir açıklama ile yeniden açma isteği gönderebilirsiniz.",
    detail_reopen_approval: "Admin onayı gerekir",
    detail_reopen_placeholder: "Bu talebi neden yeniden açmak istiyorsunuz?",
    detail_reopen_submit_btn: "Yeniden açma isteği gönder",
    detail_rejected_notice: "Bu talep reddedildi. Yeni bir konu için lütfen yeni talep oluşturun.",
    detail_reply_placeholder: "Bir yanıt yazın…",
    detail_reply_send_btn: "Gönder",
    detail_toast_sent_title: "Gönderildi",
    detail_toast_sent_desc: "Yanıt eklendi.",
    detail_toast_closed_title: "Kapatıldı",
    detail_toast_closed_desc: "Talep çözüldü olarak işaretlendi.",
    detail_toast_reopened_title: "İstek gönderildi",
    detail_toast_reopened_desc: "Yeniden açma isteğiniz ekibe iletildi.",

    // Statuses
    status_open: "Açık",
    status_in_progress: "İşlemde",
    status_waiting_customer: "Yanıtınız Bekleniyor",
    status_resolved: "Çözüldü",
    status_reopen_requested: "Yeniden Açma İsteği",
    status_closed: "Kapalı",
    status_rejected: "Reddedildi",

    // Priorities
    priority_low: "Düşük",
    priority_normal: "Normal",
    priority_high: "Yüksek",
    priority_urgent: "Acil",

    // Types
    type_bug: "Hata",
    type_feature: "Özellik Talebi",
    type_question: "Soru",

    // Destek Localization Updates (R2)
    destek_bell_aria_with_count: "{count} okunmamış bildirim, paneli aç",
    destek_bell_aria_empty: "Bildirim panelini aç",
    destek_help_aria: "Yardım",
    destek_help_title: "Yardım",
    destek_help_close_aria: "Kapat",
    destek_help_got_it: "Anladım",
    destek_action: "Aksiyon",
    destek_mark_read_aria: "{title} bildirimini okundu işaretle",
    destek_mark_read: "Okundu işaretle",
    destek_filter_aria: "Bildirim filtresi",
    destek_notifications_error_detail: "Bağlantı veya oturum geçici olarak kesilmiş olabilir.",
    destek_try_again: "Tekrar dene",
  },
  en: {
    // Nav
    nav_home: "Home",
    nav_services: "Services",
    nav_portfolio: "Portfolio",
    nav_pricing: "Pricing",
    nav_contact: "Contact",
    nav_quote: "Get a Quote",

    // Hero
    hero_badge: "End-to-End Software Service",
    hero_title_1: "We Bring Your Ideas",
    hero_title_2: "To Life",
    hero_desc: "We transform your ideas into digital reality with our expert team in mobile apps, web development, and UI/UX design.",
    hero_btn_work: "View Our Work",
    hero_btn_contact: "Contact Us",
    hero_ready_title: "Ready to Transform Your Brand?",
    hero_ready_desc: "We design digital products using the best technologies to keep you ahead of your competitors.",

    // Services
    services_eyebrow: "Our Services",
    services_title: "What We Do?",
    services_desc: "We offer 360-degree software and design solutions to strengthen your brand's digital presence.",
    srv_mobile_title: "Mobile App",
    srv_mobile_desc: "High-performance, user-friendly native and cross-platform applications for iOS and Android.",
    srv_web_title: "Web Development",
    srv_web_desc: "Fast, secure, and scalable websites using modern technologies (React, Next.js).",
    srv_uiux_title: "UI/UX Design",
    srv_uiux_desc: "Aesthetic and functional interface designs centered around user experience.",
    srv_enterprise_title: "Enterprise Software",
    srv_enterprise_desc: "Custom backend and management panels that optimize your business processes.",
    srv_ecommerce_title: "E-Commerce Solutions",
    srv_ecommerce_desc: "Special e-commerce systems with secure payment infrastructure to increase your sales.",
    srv_strategy_title: "Digital Strategy",
    srv_strategy_desc: "Data-driven analysis and roadmaps to grow your brand in the digital world.",

    // Portfolio
    portfolio_title: "Portfolio",
    portfolio_desc: "Our select projects where we combine technology and aesthetics.",
    filter_all: "All",
    filter_mobile: "Mobile App",
    filter_web: "Website",
    project_platform: "PLATFORM",
    project_type: "PROJECT TYPE",
    project_type_val: "End-to-End Development",
    back_to_portfolio: "Go Back",
    project_not_found: "Project Not Found",
    back_home: "Back to Portfolio",
    visit_site: "Visit Site",

    // Pricing
    pricing_eyebrow: "Pricing",
    pricing_title: "Project Packages",
    pricing_desc: "Choose the solution that best fits your needs.",
    price_starting: "(excl. VAT)",
    pricing_final_note: "The final price is set by a written quote and contract based on the project scope.",
    plan_startup: "Startup",
    plan_business: "Business",
    plan_enterprise: "Enterprise",
    price_quote: "Get a Quote",
    plan_btn: "Contact Us",
    most_popular: "MOST POPULAR",

    // Pricing Features
    feat_corp_web: "Corporate Website (5 Pages)",
    feat_seo: "Basic SEO Settings",
    feat_mobile: "Mobile Compatible Design",
    feat_contact: "Contact Form Integration",
    feat_adv_app: "Advanced Web or Mobile App",
    feat_custom_ui: "Custom UI/UX Design",
    feat_cms: "Management Panel (CMS)",
    feat_blog: "Blog / News Module",
    feat_support: "Full support after launch",
    feat_ecommerce: "Comprehensive E-Commerce / SaaS",
    feat_fullstack: "Full-Stack Development",
    feat_native: "Native Mobile App (iOS/Android)",
    feat_api: "Custom API Development",
    feat_priority: "24/7 Priority Support",
    feat_security: "Load Testing and Security Analysis",

    // Contact
    contact_eyebrow: "Contact",
    contact_title: "Have an Idea?",
    contact_desc: "Tell us about your project. Let's build the most suitable digital solution for you together.",
    lbl_name: "Full Name",
    lbl_email: "Email",
    lbl_phone: "Phone",
    lbl_whatsapp: "WhatsApp",
    lbl_message: "Your Message",
    lbl_subject: "Subject",
    btn_send: "Send",
    lbl_address: "Address",
    contact_form_title: "Get in Touch",
    contact_success_title: "Message Received!",
    contact_success_desc: "We will contact you as soon as possible.",
    contact_sending: "Sending...",
    ph_name: "John Doe",
    ph_email: "example@company.com",
    ph_subject: "A short title about your project",
    ph_message: "Tell us about your project details...",

    // Footer
    footer_desc: "We produce creative design and strong software solutions for brands that want to leave a mark in the digital world.",
    quick_links: "Quick Links",
    rights_reserved: "All rights reserved.",
    designed_in: "Designed with passion in Istanbul.",

    // Cookie consent (#125)
    consent_title: "Cookie preferences",
    consent_body: "We only run optional analytics, such as visit statistics and advertising measurement, with your consent. If you decline, none of these measurements are made. You can change your choice at any time and read the details in the",
    consent_privacy_link: "Privacy Policy",
    consent_body_after: "page.",
    consent_reject: "Decline",
    consent_accept: "Accept all",
    consent_current_accepted: "Your current choice: optional analytics is on.",
    consent_current_rejected: "Your current choice: optional analytics is off.",
    consent_close: "Close",
    consent_preferences_link: "Cookie preferences",

    // Privacy policy (#125)
    privacy_eyebrow: "Privacy",
    privacy_title: "Privacy Policy",
    privacy_intro_p1: "MBBE SOFTWARE processes personal data shared on the website and during the quote request only to evaluate the request, verify your phone, contact you, run the service, and for security.",
    privacy_intro_p2: "The quote form is not used for campaigns, advertising, promotions, newsletters, or bulk marketing. Phone and e-mail are used only to get back to you about your own request.",
    privacy_retention: "Personal data is kept for as long as needed for its purpose and at most 1 year. For visit statistics this period is 180 days and data is deleted automatically when it expires. Security records, SMS verification status, and operation logs are also kept only for a limited time.",
    privacy_kvkk_prefix: "For controller details, categories, legal bases, transfers, cross-border transfers, and how to apply, see the",
    privacy_kvkk_link: "Disclosure on the Processing of Personal Data",
    privacy_kvkk_suffix: ".",
    privacy_cookie_title: "Cookies and optional analytics",
    privacy_cookie_intro: "We collect visit statistics only with your explicit consent. If you do not consent, no analytics record is created; however your address is still counted briefly in Redis counters for abuse and rate-limit protection. You can change your choice anytime via “Cookie preferences” in the footer.",
    privacy_cookie_what_title: "What is collected",
    privacy_cookie_what_body: "When you consent, we store the visited page path and project link, timestamp (stored as absolute time; reports are shown in Europe/Istanbul), browser info (user agent), referrer, approximate location (country/region/city), and a keyed visitor identity derived from your IP. The raw IP is never stored in the database.",
    privacy_cookie_gtm_title: "Google Tag Manager",
    privacy_cookie_gtm_body: "The site loads Google Tag Manager (GTM-NFD67QXZ) with Google Consent Mode v2. Consent defaults (ad_storage, analytics_storage, ad_user_data, ad_personalization) start as denied and stay denied until you choose “Accept all”; your choice is mirrored to those flags. When you grant consent, data may be sent to Google.",
    privacy_cookie_geo_title: "Geolocation (IPinfo)",
    privacy_cookie_geo_body: "For consented requests only, your raw IP is sent to api.ipinfo.io to look up country/region/city; only the returned country/region/city is stored. This transfer happens only for events marked with granted consent.",
    privacy_cookie_consent_title: "How consent works",
    privacy_cookie_consent_body: "Your choice is stored in your browser (mbbe_cookie_consent, version 1). Only an explicit, current “accepted” choice starts measurement; if there is no choice, you declined, the version is old, or storage cannot be read, no measurement is made. Withdrawing consent stops tracking immediately. The server accepts only requests marked with granted consent (analyticsConsent: granted).",
    privacy_cookie_combined_title: "Analytics and security telemetry",
    privacy_cookie_combined_body: "Optional visit statistics and security/telemetry records are described together in one notice (product decision of 2026-10-12). page_visits records are kept in PostgreSQL for 180 days and auto-deleted; rate-limit counters keyed on the client address live in Redis with a short expiry (TRACK_RATE_LIMIT_WINDOW_SECONDS) and are not affected by the 180-day purge. Storage is separate, the notice is joint.",
    privacy_cookie_retention_title: "Retention and deletion",
    privacy_cookie_retention_body: "Analytics records are kept for 180 days and deleted automatically when the period ends. Deleted rows may remain in backups until the backup retention expires. An administrator can delete records for a single visitor by the supplied IP or displayed identity.",
    privacy_cookie_ip_title: "IP and visitor identity",
    privacy_cookie_ip_body: "Your IP is pseudonymized with HMAC-SHA256 and a server-held secret (hashed_ip). The identity cannot be computed without the key; if the table alone leaks, addresses cannot be recovered without the key. If no key is configured, no identity is stored — visits are counted but not linked to a visitor.",
    privacy_cookie_withdraw_title: "Changing your choice",
    privacy_cookie_withdraw_body: "To change your choice, click “Cookie preferences” in the footer and update with “Decline” or “Accept all.” The change applies immediately in all open tabs.",
    privacy_disclaimer: "This page is not legal advice. It will be reviewed by a lawyer after publication.",

    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    learn_more: "Learn More",
    no_image: "No Image",

    // NotFound
    notfound_title: "Page Not Found",
    notfound_desc: "The page you're looking for doesn't exist or may have been moved.",
    notfound_home: "Go Home",

    // Contact Form Toggle
    contact_show_form: "Show Contact Form",
    contact_hide_form: "Hide Form",

    // Destek Layout & Header
    destek_support: "Support",
    destek_logout: "Sign Out",
    destek_notifications: "Notifications",
    destek_unread_count: "unread support request",
    destek_no_unread: "No unread notifications",
    destek_close_panel: "Close notifications panel",
    destek_refresh: "Refresh",
    destek_mark_all_read: "Mark all read",
    destek_filter_all: "All",
    destek_filter_unread: "Unread",
    destek_filter_action: "Action required",
    destek_group_action: "Action required",
    destek_group_reply: "Team replies",
    destek_group_completed: "Resolved / closed",
    destek_group_rejected: "Rejected / error",
    destek_loading_notifications: "Loading notifications",
    destek_notifications_load_error: "Failed to load notifications. Please try again.",

    // Push Notification Prompt
    push_unsupported: "This browser does not support push notifications. Keep the panel open to fetch updates dynamically.",
    push_granted: "Notifications are enabled. This device receives support alerts.",
    push_denied: "Notifications are disabled. You can re-enable them in browser settings.",
    push_prompt_title: "Notify me on team replies",
    push_prompt_desc: "Show browser alerts on this device only for support replies and action-required requests.",
    push_waiting_permission: "Awaiting permission",
    push_enable: "Enable notifications",
    push_later: "Later",
    push_dismiss_aria: "Dismiss notification alert",

    // Login Page
    login_title_desc: "Sign in for your support requests",
    login_email: "Email",
    login_password: "Password",
    login_btn: "Sign In",
    login_contact_team: "Contact our team for access credentials.",
    login_failed_title: "Failed",
    login_invalid_credential: "Incorrect email or password.",
    login_too_many_requests: "Too many attempts. Please try again later.",
    login_generic_error: "Unable to sign in. Please try again.",
    login_not_customer: "This account does not have access to the support portal.",
    login_unverified: "Authentication failed. Please try again.",

    // Issue List Page
    list_title: "Your Support Requests",
    list_desc: "View and track the support requests you have created.",
    list_new_btn: "New Request",
    list_search_placeholder: "Search requests...",
    list_search_aria: "Search",
    list_empty: "You have not created any support requests yet.",
    list_load_more: "Load more",
    list_relative_just_now: "just now",

    // New Issue Page
    new_title: "New Support Request",
    new_desc: "Please explain your issue in as much detail as possible.",
    new_back_btn: "Back to requests",
    new_input_title: "Title",
    new_input_title_placeholder: "Automatically generated if left blank (e.g., Montajcım_#3)",
    new_input_project: "Project *",
    new_input_project_placeholder: "Select project...",
    new_input_type: "Type",
    new_input_priority: "Priority",
    new_input_desc: "Description",
    new_input_desc_placeholder: "Explain the issue step-by-step, at least 150 characters...",
    new_images_label: "Images (at least 1)",
    new_images_empty: "Add screenshot",
    new_image_field_empty: "Add image",
    new_max_images_reached: "Maximum image count reached.",
    new_file_field_select: "Select file",
    new_file_uploaded: "Uploaded",
    new_file_upload_failed: "Failed to upload",
    new_file_uploading: "Uploading",
    new_file_remove_aria: "remove file",
    new_file_retry: "Retry",
    new_file_limit: "up to {max} MB per file",
    new_file_types: "Supported types: PDF, ZIP, TXT, CSV, DOCX, and XLSX.",
    new_file_error_image: "Add images through the Image Upload field.",
    new_image_upload_failed: "The image could not be uploaded. Remove the file and add it again.",
    new_file_error_empty: "Empty files cannot be uploaded.",
    new_file_error_type: "This file type is not supported.",
    new_file_error_size: "The file exceeds this field's {max} MB limit.",
    new_project_fields: "Project Fields",
    new_select_placeholder: "Select...",
    new_char_remaining: "more characters required",
    new_char_count: "characters",
    new_uploads_in_progress: "Uploads in progress...",
    new_submit_btn: "Submit Request",
    new_toast_success_title: "Created",
    new_toast_success_desc: "Support request created.",
    new_toast_failed_title: "Failed",
    new_toast_failed_desc: "Failed to create request.",
    new_toast_wait_title: "Please wait",
    new_toast_wait_projects: "Projects are loading, please wait.",
    new_toast_wait_uploads: "Uploads are in progress, please wait.",

    // Validation Errors
    err_project_required: "Please select a project.",
    err_title_min: "Title must be at least 3 characters.",
    err_desc_min: "At least 150 characters required.",
    err_desc_repetitive: "Do not repeat the same text; please describe your problem meaningfully.",
    err_image_min: "At least {min} images required.",
    err_image_max: "You can upload at most {max} images.",
    err_file_required: "You must upload a file for this field.",
    err_file_max: "You can upload at most 1 file.",
    err_field_required: "This field is required.",
    err_field_max: "You can enter at most {max} characters.",
    err_field_min: "At least {min} characters required.",
    err_field_repetitive: "Repeated text detected; please fill this field meaningfully.",
    err_general_image: "You must upload at least 1 image.",

    // Issue Detail Page
    detail_load_error: "Failed to load request.",
    detail_created_at: "Created",
    detail_resolve_btn: "Mark as resolved",
    detail_images_title: "Images",
    detail_conversation_title: "Conversation",
    detail_no_replies: "No replies yet. Our team will get back to you as soon as possible.",
    detail_author_team: "MBBe Team",
    detail_author_self: "You",
    detail_reopen_title: "Reopen request",
    detail_reopen_desc: "Request is closed. If the issue continues, you can send a reopen request with a brief explanation.",
    detail_reopen_approval: "Requires admin approval",
    detail_reopen_placeholder: "Why do you want to reopen this request?",
    detail_reopen_submit_btn: "Send reopen request",
    detail_rejected_notice: "This request has been rejected. Please create a new request for a new topic.",
    detail_reply_placeholder: "Type a reply...",
    detail_reply_send_btn: "Send",
    detail_toast_sent_title: "Sent",
    detail_toast_sent_desc: "Reply added.",
    detail_toast_closed_title: "Closed",
    detail_toast_closed_desc: "Request marked as resolved.",
    detail_toast_reopened_title: "Request sent",
    detail_toast_reopened_desc: "Your reopen request has been sent to the team.",

    // Statuses
    status_open: "Open",
    status_in_progress: "In Progress",
    status_waiting_customer: "Awaiting Your Response",
    status_resolved: "Resolved",
    status_reopen_requested: "Reopen Requested",
    status_closed: "Closed",
    status_rejected: "Rejected",

    // Priorities
    priority_low: "Low",
    priority_normal: "Normal",
    priority_high: "High",
    priority_urgent: "Urgent",

    // Types
    type_bug: "Bug",
    type_feature: "Feature Request",
    type_question: "Question",

    // Destek Localization Updates (R2)
    destek_bell_aria_with_count: "{count} unread notifications, open panel",
    destek_bell_aria_empty: "Open notifications panel",
    destek_help_aria: "Help",
    destek_help_title: "Help",
    destek_help_close_aria: "Close",
    destek_help_got_it: "Got it",
    destek_action: "Action",
    destek_mark_read_aria: "Mark {title} notification as read",
    destek_mark_read: "Mark as read",
    destek_filter_aria: "Notification filter",
    destek_notifications_error_detail: "Connection or session might be temporarily lost.",
    destek_try_again: "Try again",
  }
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('tr');

  const t = (key: string) => {
    return translations[language][key as keyof typeof translations['tr']] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
